import { render, staticRenderFns } from "./BalanceBlock.vue?vue&type=template&id=bc0acb88&scoped=true"
import script from "./BalanceBlock.vue?vue&type=script&lang=js"
export * from "./BalanceBlock.vue?vue&type=script&lang=js"
import style0 from "./BalanceBlock.vue?vue&type=style&index=0&id=bc0acb88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc0acb88",
  null
  
)

export default component.exports